import { render, staticRenderFns } from "./channelAudit.vue?vue&type=template&id=c4b12442&scoped=true"
import script from "./channelAudit.vue?vue&type=script&lang=js"
export * from "./channelAudit.vue?vue&type=script&lang=js"
import style0 from "./channelAudit.vue?vue&type=style&index=0&id=c4b12442&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b12442",
  null
  
)

export default component.exports